(() => {
  const initialize = () => {
    const dialog = document.getElementById('quotePopup');
    if (!dialog || dialog.dataset.initialized === 'true') return;
    dialog.dataset.initialized = 'true';
    let trigger;
    let pointerStartedOutside = false;
    const outside = (event) => {
      const rect = dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    };
    const open = (element) => {
      if (dialog.open) return;
      trigger = element;
      dialog.showModal();
      dialog.querySelector('.pooltime-quote__body').scrollTop = 0;
      document.body.classList.add('pooltime-quote-open');
    };
    document.querySelectorAll('.showpopupright').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        open(button);
      });
      button.addEventListener('keydown', (event) => {
        if (event.key === ' ') {
          event.preventDefault();
          open(button);
        }
      });
    });
    dialog.querySelector('#closeQuote').addEventListener('click', () => dialog.close());
    dialog.addEventListener('pointerdown', (event) => { pointerStartedOutside = event.target === dialog && outside(event); });
    dialog.addEventListener('click', (event) => {
      if (pointerStartedOutside && event.target === dialog && outside(event)) dialog.close();
      pointerStartedOutside = false;
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('pooltime-quote-open');
      if (trigger?.isConnected) trigger.focus({preventScroll: true});
    });
    const feedback = dialog.querySelector('.pooltime-quote__feedback');
    if (feedback) {
      open();
      feedback.focus();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
